import { render, staticRenderFns } from "./EditDetail.vue?vue&type=template&id=a33b2dd2&scoped=true"
import script from "./EditDetail.vue?vue&type=script&lang=js"
export * from "./EditDetail.vue?vue&type=script&lang=js"
import style0 from "./EditDetail.vue?vue&type=style&index=0&id=a33b2dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33b2dd2",
  null
  
)

export default component.exports